module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b0a0q"))).then(() => parcelRequire('hEqeo'));